<div class="card panel-flat-color primary-panel document-processing-entity-panel">
    <div class="panel-flat-header mb-0">
        <h3>Entity</h3>
        <div class="float-end header-button-container">
            @if ((!editModeEntityPanel || !currentRow.intakeDocumentInfo.parcelChanges) && isSubEntity()) {
                <button (click)="editEntityPanel()"
                        class="ace-btn btn-text has-icon btn-primary">
                    <i class="fa fa-pencil"></i>
                </button>
            }
            @if (editModeEntityPanel && currentRow.intakeDocumentInfo.parcelChanges && isSubEntity()) {
                <button (click)="cancelChanges()"
                        class="ace-btn btn-text has-icon btn-primary">
                    <i class="fa fa-close"></i>
                </button>
            }
            <button (click)="loadQuickSearch.emit()"
                    class="ace-btn btn-text has-icon btn-primary">
                <i class="fa fa-list"></i>
            </button>
        </div>
    </div>
    @if (associatedEntityMissing) {
        <div class="panel-flat-body pt-2 px-4 pb-4">
            <p>
                The {{ EntityTypeNames[currentRow.intakeDocumentInfo.intakeItem.entityTypeID] || 'entity' }} this
                document
                is associated with cannot be found; most likely it was deleted. Please
                <a (click)="loadQuickSearch.emit()"
                   class="clickable">search</a>
                for an entity to associate this document with and try again.
            </p>
        </div>
    } @else {
        <div class="panel-flat-body pt-2 px-4 pb-4">
            <ws-stamp [activityStatusId]="entityDetails.extendedData.parcelActivityStatusID"
                      [dataValue]="{ activatedBy: entityDetails.extendedData.parcelActivatedBy, inactivatedBy: entityDetails.extendedData.parcelInactivatedBy, activatedDateTime: entityDetails.extendedData.parcelActivatedDateTime, inactivatedDateTime: entityDetails.extendedData.parcelInactivatedDateTime }"
                      [rightOffset]="10"
                      [transaction]="entityDetails.extendedData.parcelTransaction"
                      [visible]="!entityDetails.parcel"
                      offsetFrom="bottom">
            </ws-stamp>
            <table class="entity-panel-data">
                @if (currentRow.intakeDocumentInfo.clientInstanceId) {
                    <tr>
                        <td>Client Instance:</td>
                        <td>{{ currentRow.intakeDocumentInfo.clientInstanceName }}</td>
                    </tr>
                }
                @if (entityDetails.topLevelCompany) {
                    <tr>
                        <td>Top Level Company:</td>
                        <td>
                            <a [isTargetBlank]="true"
                               [sref]="{ target: 'company', options: {companyId: entityDetails.topLevelCompany.entityId} }"
                               anchor-route>
                                {{ entityDetails.topLevelCompany.text }}
                            </a>
                        </td>
                    </tr>
                }
                @if (entityDetails.subsidiaryCompany) {
                    <tr>
                        <td>Company Name:</td>
                        <td>
                            <a [isTargetBlank]="true"
                               [sref]="{ target: 'company', options: {companyId: entityDetails.subsidiaryCompany.entityId} }"
                               anchor-route>{{ entityDetails.subsidiaryCompany.text }}
                            </a>
                        </td>
                    </tr>
                }
                @if (entityDetails.site) {
                    <tr>
                        <td>Site Name:</td>
                        <td>
                            <a [isTargetBlank]="true"
                               [sref]="{ target: 'site', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site.entityId} }"
                               anchor-route>
                                {{ entityDetails.site.text }}
                            </a>
                        </td>
                    </tr>
                }
                @if (entityDetails.parcel) {
                    <tr>
                        <td>Parcel Acct Num:</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <parcel-icon [isLinkedParcel]="entityDetails.extendedData.isParcelLinked"
                                             [parcel]="entityDetails.extendedData"
                                             class="pe-1"
                                             propTypeParam="propertyTypeAbbr"
                                             size="large">
                                </parcel-icon>
                                @if (entityDetails.extendedData.parcelAcctNum1 || entityDetails.extendedData.parcelAcctNum2 || entityDetails.extendedData.parcelPtxId) {
                                    <div [adaptivePosition]="false"
                                         [popover]="parcelAccounts"
                                         container="body"
                                         placement="right"
                                         triggers="mouseenter:mouseleave">
                                        <a [isTargetBlank]="true"
                                           [sref]="{ target: 'parcel', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site?.entityId, parcelId: entityDetails.parcel.entityId} }"
                                           anchor-route>
                                            {{ entityDetails.parcel.text }}
                                            <i class="fa fa-info-circle"></i>
                                        </a>
                                    </div>
                                } @else {
                                    <a [isTargetBlank]="true"
                                       [sref]="{ target: 'parcel', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site?.entityId, parcelId: entityDetails.parcel.entityId} }"
                                       anchor-route
                                       class="d-inline-block align-middle">
                                        {{ entityDetails.parcel.text }}
                                    </a>
                                }
                            </div>
                        </td>
                    </tr>
                }
                @if (entityDetails.extendedData?.parcelLegalDescription) {
                    <tr>
                        <td>Legal Description:</td>
                        <td>
                            {{ entityDetails.extendedData.parcelLegalDescription.substring(0, 35) }}
                            @if (!(entityDetails.extendedData.parcelLegalDescription.length <= 35)) {
                                <a (click)="showLegalDescriptionDialog()"
                                   class="editable ps-3"
                                   href>more...</a>
                            }
                        </td>
                    </tr>
                }
                @if (entityDetails.filing) {
                    <tr>
                        <td>Filing Description:</td>
                        <td><a [isTargetBlank]="true"
                               [sref]="{ target: 'parcel', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site?.entityId, parcelId: entityDetails.parcel?.entityId, annualYearID: entityDetails.annualYear?.entityId, filingId: entityDetails.filing.entityId} }"
                               anchor-route>{{ entityDetails.annualYear.text + ' ' + entityDetails.filing.text + ' ' + entityDetails.extendedData.filingTypeName }}</a>
                        </td>
                    </tr>
                }
                @if (entityDetails.revision && !entityDetails.appeal) {
                    <tr>
                        <td>Asmt Revision:</td>
                        <td>
                            <a [isTargetBlank]="true"
                               [sref]="{ target: 'parcel', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site?.entityId, parcelId: entityDetails.parcel?.entityId, annualYearID: entityDetails.annualYear?.entityId, annualAssessmentID: entityDetails.revision.entityId} }"
                               anchor-route>
                                @if (entityDetails.annualYear) {
                                    <span>{{ entityDetails.annualYear.text }}</span>
                                }
                                {{ entityDetails.revision.text }}
                            </a>
                        </td>
                    </tr>
                }
                @if (entityDetails.appeal) {
                    <tr>
                        <td>Appeal Description:</td>
                        <td>
                            <a [isTargetBlank]="true"
                               [sref]="{ target: 'parcel', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site?.entityId, parcelId: entityDetails.parcel?.entityId, annualYearID: entityDetails.annualYear?.entityId, annualAssessmentID: entityDetails.revision?.entityId, appealID: entityDetails.appeal.entityId} }"
                               anchor-route>
                                @if (entityDetails.annualYear) {
                                    <span>{{ entityDetails.annualYear.text }}</span>
                                }
                                {{ entityDetails.appeal.text }}
                            </a>
                        </td>
                    </tr>
                }
                @if (entityDetails.taxBill && entityDetails.collector) {
                    <tr>
                        <td>Bill Description:</td>
                        <td><a [isTargetBlank]="true"
                               [sref]="{ target: 'parcel', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site?.entityId, parcelId: entityDetails.parcel?.entityId, annualYearID: entityDetails.annualYear?.entityId, billClusterID: entityDetails.billCluster?.entityId} }"
                               anchor-route>{{ entityDetails.taxBill.text }}</a></td>
                    </tr>
                }
                @if (entityDetails.refund && entityDetails.collector) {
                    <tr>
                        <td>Refund Description:</td>
                        <td>
                            <a [isTargetBlank]="true"
                               [sref]="{ target: 'parcel', options: {companyId: entityDetails.subsidiaryCompany?.entityId, siteId: entityDetails.site?.entityId, parcelId: entityDetails.parcel?.entityId, annualYearID: entityDetails.annualYear?.entityId, refundID: entityDetails.refund.entityId} }"
                               anchor-route>
                                @if (entityDetails.annualYear) {
                                    <span>{{ entityDetails.annualYear.text }}</span>
                                }
                                {{ entityDetails.collector.text }}
                            </a>
                        </td>
                    </tr>
                }
                @if (entityDetails.annualYear && entityDetails.extendedData) {
                    <!-- So-called "extended data" (that pretty much means things we didn't know we needed at first) -->
                    <tr>
                        <td>Assessee Name:</td>
                        <td>
                            @if (!currentRow.intakeDocumentInfo.parcelChanges) {
                                <span>{{ entityDetails.extendedData.assesseeName }}</span>
                            } @else {
                                <div [isOpen]="isOverridden('assesseeName')"
                                     [ngClass]="{'overridden': isOverridden('assesseeName')}"
                                     [popover]="entityDetails.extendedData.assesseeName"
                                     popoverTitle="Original Value"
                                     triggers="mouseenter:mouseleave">
                                    @if (!editModeEntityPanel) {
                                        <span>{{ currentRow.intakeDocumentInfo.parcelChanges.assesseeName }}</span>
                                    } @else {
                                        <input [(ngModel)]="currentRow.intakeDocumentInfo.parcelChanges.assesseeName"
                                               class="form-control"
                                               maxlength="100"
                                               type="text">
                                    }
                                </div>
                            }
                        </td>
                    </tr>
                }
                @if (entityDetails.annualYear && entityDetails.extendedData) {
                    <tr>
                        <td class="align-top">Situs:</td>
                        <td>
                            @if (!currentRow.intakeDocumentInfo.parcelChanges) {
                                <address-view-edit [address]="entityDetails.extendedData.parcelAddress"
                                                   [isEditMode]="false"
                                                   [isSmall]="true"
                                                   [readOnlyState]="true"
                                                   [shouldRestrictExtended]="true">
                                </address-view-edit>
                            } @else {
                                <div>
                                    @if (!editModeEntityPanel) {
                                        <address>
                                            <span [isOpen]="isOverridden('address1', true)"
                                                  [ngClass]="{'overridden': isOverridden('address1', true)}"
                                                  [popover]="entityDetails.extendedData.parcelAddress?.address1"
                                                  popoverTitle="Original Value"
                                                  triggers="mouseenter:mouseleave">{{ currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.address1 }}</span>
                                            <br>
                                            <span [isOpen]="isOverridden('address2', true)"
                                                  [ngClass]="{'overridden': isOverridden('address2', true)}"
                                                  [popover]="entityDetails.extendedData.parcelAddress?.address2"
                                                  popoverTitle="Original Value"
                                                  triggers="mouseenter:mouseleave">{{ currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.address2 }}</span>
                                            @if (currentRow.intakeDocumentInfo.parcelChanges?.parcelAddress?.address2) {
                                                <br>
                                            }
                                            <span [isOpen]="isOverridden('city', true)"
                                                  [ngClass]="{'overridden': isOverridden('city', true)}"
                                                  [popover]="entityDetails.extendedData.parcelAddress?.city"
                                                  popoverTitle="Original Value"
                                                  triggers="mouseenter:mouseleave">{{ currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.city }}</span>
                                            @if (currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.city) {
                                                <span>,</span>
                                            } {{ entityDetails.extendedData.parcelState?.abbr }}
                                            <span [isOpen]="isOverridden('zip', true)"
                                                  [ngClass]="{'overridden': isOverridden('zip', true)}"
                                                  [popover]="entityDetails.extendedData.parcelAddress?.zip"
                                                  popoverTitle="Original Value"
                                                  triggers="mouseenter:mouseleave">{{ currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.zip }}</span>
                                        </address>
                                    } @else {
                                        <div class="d-flex flex-column">
                                            <!-- Hack to remove whitespace between inputs -->
                                            <div>
                                                <input [(ngModel)]="currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.address1"
                                                       [isOpen]="isOverridden('address1', true)"
                                                       [ngClass]="{'overridden': isOverridden('address1', true)}"
                                                       [popover]="entityDetails.extendedData.parcelAddress?.address1"
                                                       class="form-control"
                                                       maxlength="50"
                                                       placeholder="Address 1"
                                                       popoverTitle="Original Value"
                                                       triggers="mouseenter:mouseleave"
                                                       type="text">
                                            </div>
                                            <div>
                                                <input [(ngModel)]="currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.address2"
                                                       [isOpen]="isOverridden('address2', true)"
                                                       [ngClass]="{'overridden': isOverridden('address2', true)}"
                                                       [popover]="entityDetails.extendedData.parcelAddress?.address2"
                                                       class="form-control"
                                                       maxlength="50"
                                                       placeholder="Address 2"
                                                       popoverTitle="Original Value"
                                                       triggers="mouseenter:mouseleave"
                                                       type="text">
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <input [(ngModel)]="currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.city"
                                                       [isOpen]="isOverridden('city', true)"
                                                       [ngClass]="{'overridden': isOverridden('city', true)}"
                                                       [popover]="entityDetails.extendedData.parcelAddress?.city"
                                                       class="form-control address-inline"
                                                       maxlength="50"
                                                       placeholder="City"
                                                       popoverTitle="Original Value"
                                                       triggers="mouseenter:mouseleave"
                                                       type="text">
                                                <span class="py-0 px-2"
                                                      style="font-size: 14px;">{{ entityDetails.extendedData.parcelState?.abbr }}</span>
                                                <input [(ngModel)]="currentRow.intakeDocumentInfo.parcelChanges.parcelAddress.zip"
                                                       [isOpen]="isOverridden('zip', true)"
                                                       [ngClass]="{'overridden': isOverridden('zip', true)}"
                                                       [popover]="entityDetails.extendedData.parcelAddress?.zip"
                                                       class="form-control address-inline"
                                                       maxlength="10"
                                                       placeholder="Zip"
                                                       popoverTitle="Original Value"
                                                       triggers="mouseenter:mouseleave"
                                                       type="text">
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </td>
                    </tr>
                }
                @if (entityDetails.revision && !entityDetails.appeal && entityDetails.extendedData) {
                    <tr>
                        <td>Assessment Class(es):</td>
                        <td>
                            @if (entityDetails.extendedData.assessmentClasses) {
                                <span>
                                    @for (aClass of entityDetails.extendedData.assessmentClasses; track aClass; let
                                        last = $last) {
                                        <span>
                                            {{ aClass.name }}
                                            @if (!last) {
                                                <span>,</span>
                                            }
                                        </span>
                                    }
                                </span>
                            }
                        </td>
                    </tr>
                }
                @if (entityDetails.extendedData?.assessorAbbr) {
                    <tr>
                        <td>Assessor Abbr:</td>
                        <td>
                            <span (mouseover)="addressPopoverData = entityDetails.extendedData.assessorAddress"
                                  [popover]="assessorAddress"
                                  triggers="mouseenter:mouseleave">
                                <a [isTargetBlank]="true"
                                   [sref]="{ target: 'assessor', options: {stateId: entityDetails.extendedData.assessorStateID, id: entityDetails.extendedData.assessorID} }"
                                   anchor-route>
                                    {{ entityDetails.extendedData.assessorAbbr }}
                                </a>
                            </span>
                        </td>
                    </tr>
                }
                @if (entityDetails.extendedData?.prevYearInfo) {
                    <tr>
                        <td>{{ +entityDetails.annualYear.text - 1 }} {{ marketValueText }}</td>
                        <td [ngClass]="{'projected': entityDetails.extendedData.prevYearInfo.isProjected}">{{ entityDetails.extendedData.prevYearInfo.totalAssessedValue | number:'1.0-0' }}
                            | {{ entityDetails.extendedData.prevYearInfo.totalFMV | number:'1.0-0' }}
                        </td>
                    </tr>
                }
                @if (entityDetails.extendedData?.collectorStateID) {
                    <tr>
                        <td>Collector Abbr:</td>
                        <td>
                            <span (mouseover)="addressPopoverData = entityDetails.extendedData.collectorAddress"
                                  [popover]="assessorAddress"
                                  triggers="mouseenter:mouseleave">
                                @if (entityDetails.extendedData.isCompanyCollector) {
                                    @if (entityDetails.topLevelCompany) {
                                        <a [isTargetBlank]="true"
                                           [sref]="{ target: 'companyCollector', options: {companyID: entityDetails.topLevelCompany.entityId, collectorID: entityDetails.collector.entityId} }"
                                           anchor-route>
                                            {{ entityDetails.collector.text }}
                                        </a>
                                    } @else if (entityDetails.subsidiaryCompany) {
                                        <a [isTargetBlank]="true"
                                           [sref]="{ target: 'companyCollector', options: {companyID: entityDetails.subsidiaryCompany.entityId, collectorID: entityDetails.collector.entityId} }"
                                           anchor-route>
                                            {{ entityDetails.collector.text }}
                                        </a>
                                    }
                                } @else {
                                    <a [isTargetBlank]="true"
                                       [sref]="{ target: 'collector', options: {stateId: entityDetails.extendedData.collectorStateID, stateCollectorId: entityDetails.collector.entityId} }"
                                       anchor-route>
                                        {{ entityDetails.collector.text }}
                                    </a>
                                }
                            </span>
                        </td>
                    </tr>
                }
                @if (entityDetails.extendedData?.parcelCollectorID) {
                    <tr>
                        <td>Collector Acct Num:</td>
                        <td>
                            @if (!currentRow.intakeDocumentInfo.parcelChanges) {
                                <span>{{ entityDetails.extendedData.collectorAcctNum }}</span>
                            } @else {
                                <div [isOpen]="isOverridden('collectorAcctNum')"
                                     [ngClass]="{'overridden': isOverridden('collectorAcctNum')}"
                                     [popover]="entityDetails.extendedData.collectorAcctNum"
                                     popoverTitle="Original Value"
                                     triggers="mouseenter:mouseleave">
                                    @if (!editModeEntityPanel) {
                                        <span>{{ currentRow.intakeDocumentInfo.parcelChanges.collectorAcctNum }}</span>
                                    } @else {
                                        <input [(ngModel)]="currentRow.intakeDocumentInfo.parcelChanges.collectorAcctNum"
                                               class="form-control"
                                               maxlength="35"
                                               type="text">
                                    }
                                </div>
                            }
                        </td>
                    </tr>
                }
                @if (entityDetails.extendedData?.parcelTaxSetup?.hasAvailableTaxSetup) {
                    <tr>
                        <td>Tax Rates:</td>
                        @if (!currentRow.intakeDocumentInfo.parcelChanges?.newTaxSetup) {
                            <td>
                                @if (entityDetails.extendedData.parcelTaxSetup.taxRateAreaName || entityDetails.extendedData.parcelTaxSetup.taxRateAreaCode || entityDetails.extendedData.parcelTaxSetup.taxAuthorityCount > 0) {
                                    <span (click)="openTaxSetupModal()"
                                          class="anchor-style">
                                        @if (entityDetails.extendedData.parcelTaxSetup.taxRateAreaName || entityDetails.extendedData.parcelTaxSetup.taxRateAreaCode) {
                                            <span>TRA: {{ entityDetails.extendedData.parcelTaxSetup.taxRateAreaName }}
                                                @if (entityDetails.extendedData.parcelTaxSetup.taxRateAreaCode) {
                                                    <span>({{ entityDetails.extendedData.parcelTaxSetup.taxRateAreaCode }}
                                                        )</span>
                                                }
                                            </span>
                                        }
                                        @if (entityDetails.extendedData.parcelTaxSetup.taxAuthorityCount > 0) {
                                            <span>
                                                Rate composed
                                                of {{ entityDetails.extendedData.parcelTaxSetup.taxAuthorityCount }}
                                                tax {{ entityDetails.extendedData.parcelTaxSetup.taxAuthorityCount === 1 ? 'authority' : 'authorities' }}
                                            </span>
                                        }
                                    </span>
                                }
                                @if (!(entityDetails.extendedData.parcelTaxSetup.taxRateAreaName || entityDetails.extendedData.parcelTaxSetup.taxRateAreaCode || entityDetails.extendedData.parcelTaxSetup.taxAuthorityCount > 0)) {
                                    <span>
                                        @if (editModeEntityPanel) {
                                            <span (click)="openTaxSetupModal()"
                                                  class="anchor-style">Setup tax rates</span>
                                        } @else {
                                            <span>None set, rates available</span>
                                        }
                                    </span>
                                }
                            </td>
                        } @else {
                            <td>
                                @if (currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxRateAreaName || currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxRateAreaCode || currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxAuthorityCount > 0) {
                                    <span (click)="openTaxSetupModal()"
                                          class="anchor-style overridden">
                                        @if (currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxRateAreaName || currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxRateAreaCode) {
                                            <span>
                                                TRA: {{ currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxRateAreaName }}
                                                @if (currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxRateAreaCode) {
                                                    <span>({{ currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxRateAreaCode }}
                                                        )</span>
                                                }
                                            </span>
                                        }
                                        @if (currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxAuthorityCount > 0) {
                                            <span>
                                                Rate composed
                                                of {{ currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxAuthorityCount }}
                                                tax {{ currentRow.intakeDocumentInfo.parcelChanges.newTaxSetup.taxAuthorityCount === 1 ? 'authority' : 'authorities' }}
                                            </span>
                                        }
                                    </span>
                                } @else {
                                    <span>
                                        @if (editModeEntityPanel) {
                                            <span (click)="openTaxSetupModal()"
                                                  class="anchor-style">Setup tax rates</span>
                                        } @else {
                                            <span>None set, rates available</span>
                                        }
                                    </span>
                                }
                            </td>
                        }
                    </tr>
                }
                @if (selectedEntity?.entityTypeId === 9 && revisionInfo) {
                    <tr>
                        <td>{{ marketValueText }}</td>
                        <td>
                            @if (loadingRevisionData) {
                                <i class="fa fa-spinner fa-pulse mt-3"></i>
                            } @else {
                                <span [ngClass]="{'projected': revisionInfo.isProjected}">
                                    {{ revisionInfo.totalAssessedValue | number:'1.0-0' }}
                                    | {{ revisionInfo.totalFMV | number:'1.0-0' }}
                                </span>
                            }
                        </td>
                    </tr>
                }
                <!-- End extended data -->
            </table>

            <button (click)="reloadEntity()"
                    class="ace-btn btn-sm btn-primary position-absolute"
                    style="right: 1em; bottom: 1em;"
                    type="button">Reload Entity
            </button>
        </div>
    }
</div>

<ng-template #assessorAddress>
    <address>
        <strong>{{ addressPopoverData.name }}</strong> <br>
        {{ addressPopoverData.address?.address1 }} @if (addressPopoverData.address?.address1) {
        <br>
    }
        {{ addressPopoverData.address?.address2 }} @if (addressPopoverData.address?.address2) {
        <br>
    }
        {{ addressPopoverData.address?.city }}
        , {{ addressPopoverData.address?.state?.abbr }} {{ addressPopoverData.address?.zip }}
    </address>
</ng-template>

<ng-template #parcelAccounts>
    @if (entityDetails.extendedData?.parcelAcctNum2) {
        <p><b>Parcel #2: </b>{{ entityDetails.extendedData.parcelAcctNum2 }}</p>
    }
    @if (entityDetails.extendedData?.parcelAcctNum1) {
        <p><b>Account #: </b>{{ entityDetails.extendedData.parcelAcctNum1 }}</p>
    }
    @if (entityDetails.extendedData?.parcelPtxId) {
        <p><b>PTX ID: </b>{{ entityDetails.extendedData.parcelPtxId }}</p>
    }
</ng-template>

